<template>
  <div class="user">
    <head-bar
      ref="headbar"
      @operate="operate"
      @cancel="cancel"
      @add="addMember"
      @remove="removeMember"
    ></head-bar>
    <div style="margin: 10px 20px 5px 20px;">
      <a-input-search
        placeholder="请输入成员电话"
        allowClear
        @search="handleSearch"
        v-model="searchText"
        enterButton
      />
    </div>
    <div
      class="content-wrapper"
      v-infinite-scroll="getData"
      :infinite-scroll-disabled="loading"
      :infinite-scroll-distance="10"
    >
      <a-checkbox-group style="width:100%" v-model="selected">
        <a-list :dataSource="dataSource" size="small" style="margin-top:15px">
          <a-list-item slot="renderItem" slot-scope="item">
            <a-list-item-meta :description="item.tel">
              <a-row slot="title" type="flex" :gutter="5" style="width:160px">
                <a-col>
                  <a-tag v-if="item.user_role === 'MASTER'" color="#f50"
                    >群主</a-tag
                  >
                </a-col>
                <a-col class="ellipsis">{{ item.name }}</a-col>
              </a-row>
              <a-avatar
                slot="avatar"
                shape="square"
                :src="item.avatar || face"
              />
            </a-list-item-meta>
            <div>
              <a-checkbox
                :value="item"
                v-show="editState"
                v-if="!item.is_join"
              ></a-checkbox>
              <a-icon
                style="color:#999;font-size:18px"
                theme="filled"
                type="check-square"
                v-else
              />
            </div>
          </a-list-item>
          <div v-show="loading" class="loading" style="text-align:center">
            <a-spin tip="加载中..." />
          </div>
        </a-list>
      </a-checkbox-group>
    </div>
  </div>
</template>

<script>
import Api from "@/api";
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("im");
import HeadBar from "./headbar";
import debounce from "lodash/debounce";
import ImgBind from "@/shared/utils/imgBind";
export default {
  name: "UserCard",
  data() {
    this.getData = debounce(this.getData, 1000);
    return {
      loading: false,
      face: require("@/assets/avatar.png"),
      busy: false,
      dataSource: [],
      preDataSource: [],
      searchText: "",
      current: 1,
      selected: [],
      editState: false,
    };
  },
  inject: ["closeConversation"],
  components: { HeadBar },
  computed: {
    ...mapState(["currentConversation"])
  },
  created() {},
  methods: {
    handleSearch() {
      this.current = 1;
      if (this.$refs.headbar.status === 2) {
        this.getUserList();
      } else {
        this.getMemberList();
      }
    },
    getData() {
      if (this.busy) {
        return;
      }
      if (this.$refs.headbar.status === 2) {
        this.getUserList();
      } else {
        this.getMemberList();
      }
    },
    async getMemberList() {
      this.loading = true;
      let params = {
        group_id: this.currentConversation.groupProfile.groupID,
        user_mobile: this.searchText.trim(),
        page: this.current,
        limit: 30
      };
      try {
        var response = await Api.im.groupMemberList(params);
        this.dataSource =
          this.current === 1
            ? [...response.list]
            : [...this.dataSource, ...response.list];
        if (this.current * 30 < response.total) {
          this.current++;
        } else {
          this.busy = true;
        }
      } catch (err) {}
      this.loading = false;
    },
    async getUserList() {
      this.loading = true;
      let params = {
        group_id: this.currentConversation.groupProfile.groupID,
        tels: this.searchText,
        page: this.current,
        limit: 30
      };
      try {
        var response = await Api.im.userList(params);
        this.dataSource =
          this.current === 1
            ? [...response.list]
            : [...this.dataSource, ...response.list];
        if (this.current * 30 < response.total) {
          this.current++;
        } else {
          this.busy = true;
        }
      } catch (err) {}
      this.loading = false;
    },
    async operate(status) {
      this.searchText = "";
      if (status === 2) {
        //添加
        this.preDataSource = [...this.dataSource];
        this.current = 1;
        this.busy = false;
        await this.getUserList();
      }
      this.editState = true;
    },
    async cancel(status) {
      this.editState = false;
      this.selected = [];
      if (status === 2) {
        this.current = 1;
        this.busy = false;
        return this.getMemberList();
      }
    },
    async addMember() {
      if (this.selected.length > 0) {
        let user_ids = this.selected.map(item => item.id).join(",");
        let groupID = this.currentConversation.groupProfile.groupID;
        await Api.im.addUser({
          group_id: groupID,
          user_ids
        });
        if (this.preDataSource.length < 9) {
          this.updateGroupAvatar(groupID, [
            ...this.preDataSource,
            ...this.selected
          ]);
        }
        setTimeout(() => {
          this.cancel(2);
          this.$refs.headbar.init();
        }, 2000);
      } else {
        this.cancel(2);
        this.$refs.headbar.init();
      }
    },
    async removeMember() {
      let hasMaster =
        this.selected.filter(item => item.user_role === "MASTER").length > 0;
      if (hasMaster) {
        this.$confirm({
          title: "警告",
          content: "剔除群主将直接解散群聊",
          onOk: () => {
            return new Promise(async (resolve, reject) => {
              await Api.im.dismissGroup({
                group_id: this.currentConversation.groupProfile.groupID
              });
              resolve();
              this.closeConversation();
            });
          },
          onCancel: () => {
            this.cancel();
            this.$refs.headbar.init();
          }
        });
      } else {
        let message = "";
        if (this.selected.length === 1) {
          message = `确定从群“${this.currentConversation.groupProfile.name}”剔除成员“${this.selected[0].name}”？`;
        } else if (this.selected.length > 1) {
          message = `确定从群“${this.currentConversation.groupProfile.name}”剔除“${this.selected[0].name}”等成员？`;
        } else {
          this.cancel();
          this.$refs.headbar.init();
          return;
        }
        this.$confirm({
          title: "提示",
          content: message,
          onOk: () => {
            return new Promise(async (resolve, reject) => {
              let user_ids = this.selected.map(item => item.id).join(",");
              await Api.im.removeUser({
                group_id: this.currentConversation.groupProfile.groupID,
                user_ids
              });
              resolve();
              await this.cancel(2);
              if (this.dataSource.length < 9) {
                this.updateGroupAvatar(
                  this.currentConversation.groupProfile.groupID,
                  [...this.dataSource]
                );
              }
              this.$refs.headbar.init();
            });
          },
          onCancel: () => {
            this.cancel();
            this.$refs.headbar.init();
          }
        });
      }
    },
    async updateGroupAvatar(group_id, member) {
      if (member.length > 9) {
        member = member.slice(0, 9);
      }
      let source = new ImgBind(member.map(item => item.avatar));
      source.loadImage().then(face_url => {
        Api.im.updateGroupAvatar({ group_id, face_url });
      });
    }
  }
};
</script>

<style scoped lang="scss">
.user {
  border-right: 1px solid #e7e7e7;
  .content-wrapper {
    height: 500px;
    overflow-y: auto;
    padding: 0 20px 8px 20px;
    position: relative;
    .loading {
      position: absolute;
      bottom: 80px;
      width: 100%;
    }
    .ellipsis {
      width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
